module.exports = __webpack_public_path__ + "img/fig9.12.f7eafd15.png";